import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import noop from 'lodash/noop';

import ArrowXL from './../icons/ArrowXL';
import ArrowL from './../icons/ArrowL';
import ArrowS from './../icons/ArrowS';

import generalStyles from './style/general.css';
import sizeStyles from './style/size.css';
import typeStyles from './style/type.css';

const selectStyles = { ...generalStyles, ...sizeStyles, ...typeStyles };
const cx = classNames.bind(selectStyles);

export default class UnderlinedSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
    };
  }

  onFocus = () => {
    this.setState({
      isFocused: true,
    });
    this.props.onFocus();
  };

  onBlur = () => {
    this.setState({
      isFocused: false,
    });
    this.props.onBlur();
  };

  render() {
    const {
      autoComplete,
      name,
      fullWidth,
      options,
      hasError,
      id,
      size,
      type,
      onChange,
      tabIndex,
      disabled,
    } = this.props;
    const { isFocused } = this.state;

    /* eslint-disable no-shadow */
    const selectOptions = options.map(
      ({ disabled, label, selected, value }) => (
        <option
          disabled={disabled}
          key={value}
          label={label}
          selected={selected}
          value={value}
        >
          {label}
        </option>
      )
    );

    const caret = (() => {
      switch (size) {
        case 'xl':
          return <ArrowXL />;
        case 'l':
          return <ArrowL />;
        case 'm':
          return <ArrowL />;
        case 's':
          return <ArrowS />;
        case 'xs':
          return <ArrowS />;
        default:
          return <ArrowL />;
      }
    })();

    const selectClasses = cx('select', {
      [type]: !(hasError || disabled),
      [`${type}IsFocused`]: isFocused && !hasError,
      'has-error': hasError,
      'is-disabled': disabled,
      'width-100': fullWidth,
    });

    const selectNativeClasses = cx('nativeControl', size);

    const selectCaretClasses = cx('caret', `caret--${size}`);

    return (
      <div className={selectClasses}>
        <select
          tabIndex={tabIndex}
          autoComplete={autoComplete}
          name={name}
          disabled={disabled}
          className={selectNativeClasses}
          onChange={onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          id={id}
        >
          {selectOptions}
        </select>

        <span className={selectCaretClasses}>
          <span className={selectStyles.table}>
            <span className={selectStyles.cell}>{caret}</span>
          </span>
        </span>
      </div>
    );
  }
}

UnderlinedSelect.propTypes = {
  autoComplete: PropTypes.string,
  name: PropTypes.string,
  fullWidth: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      label: PropTypes.node.isRequired,
      selected: PropTypes.bool,
      value: PropTypes.node,
    })
  ),
  hasError: PropTypes.bool,
  id: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(sizeStyles)).isRequired,
  type: PropTypes.oneOf(Object.keys(typeStyles)).isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  tabIndex: PropTypes.number,
  disabled: PropTypes.bool,
};

UnderlinedSelect.defaultProps = {
  size: 'm',
  type: 'default',
  onFocus: noop,
  onBlur: noop,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-select/UnderlinedSelect/index.js